(function() {
    'use strict';

    angular
        .module('uwAgenda.tasks')
        .directive('deadlineAfterAlertdate', DeadlineAfterAlertDateFn);

    // todo: wird nicht verwendet -> ev neu schreiben
    /* validator for proofing if deadline is after alert-time */
    DeadlineAfterAlertDateFn.$inject = [];
    
    function DeadlineAfterAlertDateFn() {
      
        var directive = {
            link: link,
            restrict: 'A'
           
        };
        return directive;

        function link(scope, element, attrs) {

            return scope.$watch(attrs.date, function (date) {
                if (date.value === true) {
                    // deadline must be after alerttime
                    scope.date.$validators.deadlineAfterAlertdate = function (value) {
                    };
                }
            });

           
        }
    }

})();